import { ApprovalState } from 'models/approval';

export type ListsPerTenant = { [key: string]: number[] }; // tenantId to listIds mapping

export class Widget72DTO {
  lists: ListsPerTenant;

  results?: Widget72ResultDTO[];

  constructor() {
    this.lists = {};
  }
}

export class Widget72ResultDTO {
  tenantId: string;

  data: { [K in keyof ApprovalState]?: number };

  constructor() {
    this.tenantId = '';
    this.data = {};
  }
}
